'use client';

import { Calculator } from '../calculators/calculator';
import { calculatorsMap } from '../calculators/calculators-map';
import { CalculatorId } from '../../lib/calculators/calculator-config';

interface CalculatorWrapperProps {
  calculatorId: CalculatorId;
}

export function CalculatorWrapper({ calculatorId }: CalculatorWrapperProps) {
  const calculator = calculatorsMap[calculatorId];
  if (!calculator) return null;

  return (
    <div className="h-full">
      <Calculator<typeof calculatorId> config={calculator.config} />
    </div>
  );
} 